<template>
  <div class="A4">
    <ReportHeader />
    <table class="table table-bordered table-sm table-striped no-bor">
      <thead>
        <tr style="font-size: 13px">
          <th>Date</th>
          <th>
            <!-- លេខវិក្កយបត្រ<br/> -->
            Invoice No.
          </th>
          <th>
            <!-- ឈ្មោះអតិថិជន<br/> -->
            Name in Khmer
          </th>
          <th>
            <!-- ឈ្មោះអតិថិជនឡាតាំង<br/> -->
            Name in Latin
          </th>
          <th>
            <!-- លេខអតប / លេខទូរស័ព្ទ<br/> -->
            VAT No. / Phone Number
          </th>
          <!-- <th>តម្លៃជាប់មិនអតប<br/>Non-Taxable</th>
                                <th>អតប<br/>VAT</th> -->
          <th>Amount USD</th>
          <th>Amount KHR</th>
          <!-- <th>តម្លៃជាប់អតប<br/>Taxable</th>
                                <th>សរុបតម្លៃរួមអាករ<br/>Amt. included USD</th> -->
          <!-- <th>សរុបតម្លៃរួមអាករ<br/>Amt. included KHR</th> -->
          <th>
            <!-- អត្រាប្តូប្រាក់<br/> -->
            Rate
          </th>
          <th>
            <!-- អត្រាប្តូប្រាក់<br/> -->
            Description / memo
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(ret, index) in records">
          <tr v-if="index == 0">
            <th colspan="5" class="text-right">TOTAL</th>
            <th class="text-right">{{ $money(summary.TotalAmount) }}</th>
            <th class="text-right">R {{ $number(summary.TotalAmtRiel, "0,0") }}</th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <td class="text-center">{{ $format(ret.Date, "DD/MM/YYYY") }}</td>
            <td style="width: 125px">{{ ret.Num }}</td>
            <td>{{ ret.CustomerName }}</td>
            <td>{{ ret.CustomerNameLatin }}</td>
            <td v-if="ret.VatTin && ret.TinHead">{{ ret.VatTin }}-{{ ret.TinHead }}</td>
            <td v-else>{{ ret.CustomerPhone }}</td>
            <td class="text-right">{{ $money(ret.TotalAmount) }}</td>
            <td class="text-right">
              R
              {{
                $number(
                  ret.TotalAmount
                    ? ret.TotalAmount.toFixed(2) * (ret.ExchangeRate || 4100)
                    : 0,
                  "0,0"
                )
              }}
            </td>
            <td class="text-right">{{ $number(ret.ExchangeRate || 4100) }}</td>
            <td>{{ ret.Description }}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import ReportHeader from "../../../Components/ReportHeader";
import Sale from "../../../../shared/models/Sale";
export default {
  components: { ReportHeader },
  data() {
    return {
      query: {
        CustomerId: "",
        FromDate: this.$startOfMonth(),
        ToDate: this.$endOfMonth(),
        FilterType: 3
      },
      records: [],
      summary: {
        Untax: 0,
        TaxAmount: 0,
        IncludeTax: 0,
        TotalAmount: 0,
        TotalAmtRiel: 0,
      },
    };
  },
  created() {
    let qr = this.$route.query;
    this.query.FromDate = qr.fd;
    this.query.ToDate = qr.td;
    this.query.CustomerId = qr.cs;
    this.query.CompanyId = this.$store.state.company.Id;
    this.query.FilterType = qr.ft;
    this.toList();
  },
  methods: {
    toList() {
      var loading = this.$loading.show();
      Sale.reportSaleInvoiceList(this.query)
        .then((res) => {
          this.records = res.Json.Invoices;
          this.calculate();
        })
        .finally(() => {
          loading.hide();
        });
    },
    calculate() {
      let untax = 0;
      let tax = 0;
      let inctax = 0;
      let total = 0;
      let totalRiel = 0;
      this.records.forEach((el) => {
        untax += el.GrandTotal;
        tax += el.TaxVat;
        inctax += el.IncludeTaxAmount;
        total += el.TotalAmount;
        totalRiel += el.TotalAmount * el.ExchangeRate;
      });
      this.summary.Untax = untax;
      this.summary.TaxAmount = tax;
      this.summary.IncludeTax = inctax;
      this.summary.TotalAmount = total;
      this.summary.TotalAmtRiel = totalRiel;
    },
  },
};
</script>
